<template>
  <div class="tip_wrapper">
    <img src="~@/assets/images/deal-manage/ic_tip.png"
         width="18px"
         height="17px">
    <span>{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'Tip',
  props: {
    text: {
      type: String,
      required: true
    }
  },
}
</script>
<style scoped>
.tip_wrapper {
  color: #fd5902;
  font-size: 12px;
}
.tip_wrapper img {
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/tip/index.vue